import React from 'react';
import { Box, Paper, Typography, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(amount || 0);

const BreakdownItem = ({ label, value, color, prefix = '' }) => (
  <Paper
    sx={{
      p: { xs: 1.5, sm: 2 },
      flex: { xs: '0 0 auto', sm: 1 },
      minWidth: { xs: 0, sm: 160 },
      textAlign: { xs: 'left', sm: 'center' },
      borderTop: { xs: 0, sm: 3 },
      borderLeft: { xs: 3, sm: 0 },
      borderColor: color,
    }}
  >
    <Typography variant="body2" color="textSecondary" gutterBottom>
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 600, color }}>
      {prefix}{formatCurrency(Math.abs(value))}
    </Typography>
  </Paper>
);

const AcquisitionBreakdown = ({ data }) => {
  if (!data) return null;

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={0.5} mb={1.5}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Acquisition cost breakdown
        </Typography>
        <Tooltip title="How your net acquisition cost is calculated: what you paid to acquire orders minus what you earned from sending orders to partners." arrow>
          <IconButton size="small" sx={{ padding: 0 }}>
            <InfoOutlined sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'stretch', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1,
        }}
      >
        <BreakdownItem
          label="Acquisition spend"
          value={data.acquisition_spend}
          color="warning.main"
        />
        <Typography variant="h5" color="textSecondary" sx={{ px: 0.5, textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>
          &minus;
        </Typography>
        <BreakdownItem
          label="Affiliate revenue earned"
          value={data.affiliate_revenue_earned}
          color="success.main"
        />
        <Typography variant="h5" color="textSecondary" sx={{ px: 0.5, textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>
          =
        </Typography>
        <BreakdownItem
          label="Net acquisition cost"
          value={data.net_acquisition_cost}
          color={data.net_acquisition_cost <= 0 ? 'success.main' : 'text.primary'}
        />
      </Box>
    </Box>
  );
};

export default AcquisitionBreakdown;
